export default __webpack_public_path__ + "static/media/uploader-relion-3.f7ae7f98.png";